<!-- Unified Code (DGA) nav header + nav drawer (criteria 29, 44). Custom mode renders #customNav unchanged. -->
<ng-container *ngIf="unified; else customNav">
  <header *ngIf="!isContent" class="uc-header" [class.uc-header--scrolled]="isScrolled">
    <div class="uc-header__bar">
      <a class="uc-header__brand" routerLink="/home">
        <img class="uc-header__logo" loading="lazy"
          [src]="identityModel.coloredImage ? mediaUrl + identityModel.coloredImage : 'assets/imgs/EXAB.svg'"
          [alt]="organizationName" />
        <ng-container *ngIf="identityModel.governmentLogo">
          <span class="uc-header__divider" aria-hidden="true"></span>
          <img class="uc-header__gov-logo" loading="lazy" [src]="mediaUrl + identityModel.governmentLogo"
            [alt]="'unifiedShell.header.governmentLogoAlt' | translate" />
        </ng-container>
      </a>

      <nav class="uc-header__nav d-none d-lg-block" [attr.aria-label]="'unifiedShell.header.primaryNav' | translate">
        <ng-container *ngTemplateOutlet="primaryLinks; context: { $implicit: 'bar' }"></ng-container>
      </nav>

      <div class="uc-header__utilities">
        <button type="button" class="uc-icon-btn d-none d-lg-inline-flex" [attr.aria-pressed]="!!isDark"
          [attr.aria-label]="'a11y.toggleContrast' | translate" (click)="changeTheme()">
          <i class="fa-solid fa-circle-half-stroke" aria-hidden="true"></i>
        </button>

        <div class="dropdown d-none d-lg-block">
          <button type="button" class="uc-icon-btn" data-bs-toggle="dropdown" data-bs-auto-close="outside"
            aria-expanded="false" aria-controls="uc-font-size-menu" [attr.aria-label]="'a11y.fontSize' | translate">
            <i class="fa-solid fa-font" aria-hidden="true"></i>
          </button>
          <div id="uc-font-size-menu" class="dropdown-menu uc-menu uc-menu--compact">
            <input (change)="changeFontSize($event)" type="range" class="uc-font-range" min="1" max="1.4" step="0.1"
              value="1" [attr.aria-label]="'a11y.fontSize' | translate">
          </div>
        </div>

        <a *ngIf="identityModel.enablePayment" routerLink="/check-out" class="uc-icon-btn"
          routerLinkActive="uc-icon-btn--selected" ariaCurrentWhenActive="page"
          [class.is-disabled]="paymentService.itemsInCart === 0"
          [attr.aria-disabled]="paymentService.itemsInCart === 0 ? 'true' : null"
          [attr.tabindex]="paymentService.itemsInCart === 0 ? -1 : null" [attr.aria-label]="'a11y.cart' | translate">
          <i class="fa-solid fa-cart-shopping" aria-hidden="true"></i>
          <span *ngIf="paymentService.itemsInCart > 0" class="uc-badge" aria-hidden="true">{{ paymentService.itemsInCart }}</span>
        </a>

        <a *ngIf="!isAuthorize" class="uc-header__cta d-none d-lg-inline-flex" routerLink="/join/signUp"
          routerLinkActive="uc-header__cta--selected" ariaCurrentWhenActive="page" translate="shared.newUser"></a>

        <button *ngIf="!isAuthorize" type="button" class="uc-icon-btn" (click)="login()"
          [attr.aria-label]="'auth.login' | translate">
          <i class="fa-solid fa-right-to-bracket" aria-hidden="true"></i>
        </button>

        <button type="button" class="uc-icon-btn" [class.uc-icon-btn--selected]="hideSearch" (click)="onSearch()"
          [attr.aria-expanded]="hideSearch" aria-controls="portal-search" [attr.aria-label]="'shared.search' | translate">
          <i class="fa-solid" [ngClass]="hideSearch ? 'fa-xmark' : 'fa-magnifying-glass'" aria-hidden="true"></i>
        </button>

        <div *ngIf="isAuthorize" class="dropdown">
          <button type="button" class="uc-icon-btn" data-bs-toggle="dropdown" aria-expanded="false"
            aria-controls="uc-notifications-menu" [attr.aria-label]="'shared.notifications' | translate">
            <i class="fa-regular fa-bell" aria-hidden="true"></i>
            <span *ngIf="notificationsList.length > 0" class="uc-badge" aria-hidden="true">{{ notificationsList.length }}</span>
          </button>
          <div id="uc-notifications-menu" class="dropdown-menu dropdown-menu-end uc-menu uc-menu--notifications">
            <p *ngIf="notificationsList.length === 0" class="uc-menu__empty mb-0" translate="shared.noNotifications"></p>
            <button *ngFor="let item of notificationsList" type="button" class="dropdown-item uc-menu__notification"
              (click)="seenNotification(item)">
              <span class="uc-menu__notification-text">
                <span class="uc-menu__notification-title">{{ isRtl ? item.titleAr ?? "تنبيه جديد" : item.title ?? "New Notification" }}</span>
                <span class="uc-menu__notification-message">{{ isRtl ? item.messageAr ?? item.englishMessage : item.englishMessage ?? item.messageAr }}</span>
              </span>
              <span class="uc-menu__notification-date">{{ item.createdDate | date: "dd/MM/YYYY" }}</span>
            </button>
            <a class="dropdown-item uc-menu__footer" routerLink="notifications" translate="shared.showAll"></a>
          </div>
        </div>

        <button type="button" class="uc-icon-btn d-none d-lg-inline-flex" (click)="changeLanguageParent()"
          [attr.aria-label]="'a11y.switchLanguage' | translate">
          <span class="uc-lang" [attr.lang]="isRtl ? 'en' : 'ar'">{{ isRtl ? 'EN' : 'ع' }}</span>
        </button>

        <div *ngIf="isAuthorize" class="dropdown">
          <button type="button" class="uc-avatar-btn" data-bs-toggle="dropdown" aria-expanded="false"
            aria-controls="uc-profile-menu" [attr.aria-label]="'a11y.userMenu' | translate">
            <img loading="lazy" alt=""
              [src]="user.profilePicture ? mediaUrl + user.profilePicture : user.gender === 0 ? 'assets/imgs/avatar-male.jpg' : 'assets/imgs/avatar-female.jpg'">
          </button>
          <ul id="uc-profile-menu" class="dropdown-menu dropdown-menu-end uc-menu">
            <li><a class="dropdown-item" [routerLink]="['/myspace/profile/' + user.id]" translate="mySpace.title"></a></li>
            <li><a class="dropdown-item" [routerLink]="['/join/change-password']" translate="auth.changePassword"></a></li>
            <li><button type="button" class="dropdown-item" (click)="signOut()" translate="auth.logout"></button></li>
          </ul>
        </div>

        <button #drawerToggle type="button" class="uc-icon-btn uc-drawer-toggle d-lg-none" (click)="openDrawer()"
          [attr.aria-expanded]="drawerOpen" aria-controls="uc-nav-drawer"
          [attr.aria-label]="'unifiedShell.drawer.open' | translate">
          <i class="fa-solid fa-bars" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </header>

  <!-- Nav drawer (mobile navigation, < 992px) -->
  <div *ngIf="drawerOpen && !isContent" class="uc-drawer-backdrop" aria-hidden="true" (click)="closeDrawer()"></div>
  <div *ngIf="!isContent" id="uc-nav-drawer" #drawerPanel class="uc-drawer" [class.uc-drawer--open]="drawerOpen"
    tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="uc-nav-drawer-title" [attr.hidden]="drawerOpen ? null : ''"
    (keydown)="onDrawerKeydown($event)">
    <div class="uc-drawer__header">
      <h2 id="uc-nav-drawer-title" class="uc-drawer__title uc-text-lg uc-semibold mb-0">{{ 'unifiedShell.drawer.title' | translate }}</h2>
      <button #drawerClose type="button" class="uc-icon-btn" (click)="closeDrawer()"
        [attr.aria-label]="'unifiedShell.drawer.close' | translate">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
    <nav class="uc-drawer__nav" [attr.aria-label]="'unifiedShell.header.primaryNav' | translate">
      <ng-container *ngTemplateOutlet="primaryLinks; context: { $implicit: 'drawer' }"></ng-container>
    </nav>
    <div class="uc-drawer__utilities">
      <a *ngIf="!isAuthorize" class="uc-drawer__utility" routerLink="/join/signUp" (click)="closeDrawer(false)">
        <i class="fa-solid fa-user-plus" aria-hidden="true"></i>
        <span translate="shared.newUser"></span>
      </a>
      <button type="button" class="uc-drawer__utility" [attr.aria-pressed]="!!isDark" (click)="changeTheme()">
        <i class="fa-solid fa-circle-half-stroke" aria-hidden="true"></i>
        <span>{{ 'a11y.toggleContrast' | translate }}</span>
      </button>
      <label class="uc-drawer__utility uc-drawer__utility--range">
        <i class="fa-solid fa-font" aria-hidden="true"></i>
        <span>{{ 'a11y.fontSize' | translate }}</span>
        <input (change)="changeFontSize($event)" type="range" class="uc-font-range" min="1" max="1.4" step="0.1" value="1">
      </label>
      <button type="button" class="uc-drawer__utility" (click)="changeLanguageParent()">
        <i class="fa-solid fa-globe" aria-hidden="true"></i>
        <span [attr.lang]="isRtl ? 'en' : 'ar'">{{ isRtl ? 'English' : 'العربية' }}</span>
      </button>
    </div>
  </div>

  <ng-template #primaryLinks let-variant>
    <ul class="uc-nav__list" [class.uc-nav__list--drawer]="variant === 'drawer'">
      <li *ngFor="let link of headerLinks; trackBy: trackByLinkId" class="uc-nav__item">
        <a *ngIf="link.url" class="uc-nav__link" [routerLink]="link.url" routerLinkActive="uc-nav__link--selected"
          ariaCurrentWhenActive="page" (click)="onPrimaryLinkClick(link, variant)">{{ link.labelKey ? (link.labelKey | translate) : linkText(link) }}</a>
        <a *ngIf="link.href" class="uc-nav__link" [href]="link.href" target="_blank" data-uc-external-icon rel="noopener"
          (click)="onPrimaryLinkClick(link, variant)">
          {{ link.labelKey ? (link.labelKey | translate) : linkText(link) }}
          <i class="fa-solid fa-arrow-up-right-from-square uc-external-icon" aria-hidden="true"></i>
        </a>
      </li>
    </ul>
  </ng-template>
</ng-container>

<ng-template #customNav>
<nav *ngIf="!isContent" class="navbar navbar-expand-lg sticky-top py-0">
  <div class="d-lg-flex align-items-center justify-content-between">
    <a [ngClass]="{'courses-bg': isCourses}"
      class="navbar-brand mx-0 d-inline-block p-2 d-lg-flex align-items-center justify-content-center"
      routerLink="/home">
      <img [alt]="organizationName" loading="lazy"
        [src]="identityModel.coloredImage ? mediaUrl + identityModel.coloredImage : 'assets/imgs/EXAB.svg'" />
    </a>
    <button class="navbar-toggler shadow-none border-0" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
      [attr.aria-label]="'a11y.toggleNavigation' | translate">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav navbar-nav-item me-auto mb-2 mb-lg-0 mt-3 mt-lg-0 justify-content-center">
        <li class="nav-item">
          <a class="nav-link" routerLink="/home" routerLinkActive="active" translate="home.title"></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/course" routerLinkActive="active" translate="mySpace.courses"></a>
        </li>
        <ng-template [ngxPermissionsOnly]="roles.Student">
          <li class="nav-item">
            <a class="nav-link" routerLink="/myspace/courses" routerLinkActive="active"
              translate="mySpace.myCourses"></a>
          </li>
        </ng-template>
        <li class="nav-item" *ngIf="showDigitalLibrary">
          <a (click)="otherActive()" class="nav-link" routerLinkActive="activeLink"
            [routerLink]="['digital-library/contents']">{{ "digitalLibrary.title" | translate }}
          </a>
        </li>
        <ng-template [ngxPermissionsOnly]="permissions.Settings.DashboardView">
          <li *ngIf="isAuthorize" class="nav-item">
            <a class="nav-link" [href]="dashboardUrl" target="_blank" translate="dashboard.title"></a>
          </li>
        </ng-template>
      </ul>
      <ul class="navbar-nav mx-auto mb-2 mb-lg-0 mt-4 mt-lg-0 justify-content-end">
        <li class="nav-auth">
          <a class="nav-information position-relative rounded-circle border d-flex align-items-center justify-content-center"
            role="button" tabindex="0" [attr.aria-label]="'a11y.toggleContrast' | translate" (click)="changeTheme()">
            <i class="fa-solid fa-circle-half-stroke"></i>
          </a>
        </li>
        <li class="nav-auth dropdown">
          <a class="nav-information dropdown-toggle position-relative rounded-circle border d-flex align-items-center justify-content-center"
            href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="'a11y.fontSize' | translate">
            <i class="fa-solid fa-font"></i>
          </a>
          <ul class="dropdown-menu py-0 bg-transparent border-0 text-end text-lg-center">
            <input (change)="changeFontSize($event)" type="range" class="shadow-none" min="1" max="1.4" step="0.1"
              value="1" [attr.aria-label]="'a11y.fontSize' | translate">
          </ul>
        </li>
        <li class="nav-auth" *ngIf="identityModel.enablePayment" [class.disabled]="paymentService.itemsInCart === 0">
          <a routerLink="/check-out" [attr.aria-label]="'a11y.cart' | translate"
            class="nav-information position-relative rounded-circle border d-flex align-items-center justify-content-center">
            <div class="icon-mask" style="mask-image: url(./../../../../assets/imgs/market.svg);"></div>
            <span
              class="check-out position-absolute start-100 translate-middle-x rounded-circle text-white d-flex align-items-center justify-content-center"
              style="top: -15%;">{{paymentService.itemsInCart}}</span>
          </a>
        </li>
        <li *ngIf="!isAuthorize" class="nav-auth">
          <a class="new-user text-white rounded-pill d-flex align-items-center justify-content-center"
            routerLink="/join/signUp" translate="shared.newUser"></a>
        </li>
        <li *ngIf="!isAuthorize" (click)="login()" class="nav-auth" style="cursor: pointer;">
          <a class="nav-information border rounded-circle d-flex align-items-center justify-content-center"
            role="button" tabindex="0" [attr.aria-label]="'auth.login' | translate">
            <div class="icon-mask" style="mask-image: url(./../../../../assets/imgs/login.svg);"></div>
          </a>
        </li>
        <li class="nav-auth dropdown">
          <a (click)="onSearch()" [ngClass]="{'active': hideSearch}"
            class="nav-information dropdown-toggle position-relative rounded-circle border d-flex align-items-center justify-content-center"
            href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="'shared.search' | translate">
            <i *ngIf="!hideSearch" class="fa-solid fa-magnifying-glass"></i>
            <i *ngIf="hideSearch" class="fa-solid fa-xmark"></i>
          </a>
        </li>
        <li *ngIf="isAuthorize" class="nav-auth dropdown">
          <a class="nav-information dropdown-toggle position-relative rounded-circle border d-flex align-items-center justify-content-center"
            href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="'shared.notifications' | translate">
            <div class="icon-mask" style="mask-image: url(./../../../../assets/imgs/notification.svg);"></div>
            <span *ngIf="notificationsList.length > 0"
              class="position-absolute start-50 rounded-circle text-white d-flex align-items-center justify-content-center"
              style="top: 10%;">{{notificationsList.length}}</span>
          </a>
          <ul class="dropdown-menu py-0 overflow-x-hidden overflow-y-auto" style="height: 300px;">
            <p *ngIf="notificationsList.length === 0" class="text-center mb-0 py-2" translate="shared.noNotifications">
            </p>
            <div *ngFor="let item of notificationsList" (click)="seenNotification(item)"
              class="p-2 border-bottom d-flex align-items-center justify-content-start">
              <div class="d-flex align-items-center overflow-x-hidden">
                <i class="fa-solid fa-circle"></i>
                <div [ngClass]="isRtl ? 'text-end' : 'text-start'">
                  <p class="mb-1">{{isRtl ? item.titleAr ?? "تنبيه جديد" : item.title ?? "New Notification"}}</p>
                  <p class="mb-0">{{isRtl ? item.messageAr ?? item.englishMessage : item.englishMessage ??
                    item.messageAr}}</p>
                </div>
              </div>
              <p class="mb-0">{{item.createdDate | date:"dd/MM/YYYY"}}</p>
            </div>
            <a class="d-block text-center border-top py-2" routerLink="notifications" translate="shared.showAll"></a>
          </ul>
        </li>
        <li (click)="changeLanguageParent()" class="nav-auth">
          <a role="button" tabindex="0" [attr.aria-label]="'a11y.switchLanguage' | translate"
            class="nav-information position-relative rounded-circle border d-flex align-items-center justify-content-center">
            <span *ngIf="isRtl" class="language">EN</span>
            <span *ngIf="!isRtl" class="language mb-2">ع</span>
          </a>
        </li>
        <li *ngIf="isAuthorize" class="nav-profile">
          <div class="dropdown">
            <button class="btn rounded-circle shadow-none border p-0 overflow-hidden dropdown-toggle" type="button"
              data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="'a11y.userMenu' | translate">
              <img alt="" aria-hidden="true" class="w-100 h-100 object-fit-cover" loading="lazy"
                [src]="user.profilePicture ? mediaUrl + user.profilePicture : user.gender === 0 ? 'assets/imgs/avatar-male.jpg' : 'assets/imgs/avatar-female.jpg'">
            </button>
            <ul class="dropdown-menu overflow-hidden text-center">
              <li><a class="dropdown-item mb-2" [routerLink]="['/myspace/profile/' + user.id]"
                  translate="mySpace.title"></a></li>
              <li><a class="dropdown-item mb-2" [routerLink]="['/join/change-password']"
                  translate="auth.changePassword"></a></li>
              <li><a class="dropdown-item" (click)="signOut()" translate="auth.logout"></a></li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
</ng-template>
